import React, { FC } from 'react';
import classNames from 'classnames';

import Copy from 'Src/components/Copy';
import FontIcon from 'Src/components/icons/FontIcon';
import { Flex } from 'Src/components/layout/Flex';
import { ModifierCommandPaletteChip } from 'Src/feature/modifier-command/ModifierCommandPaletteChip';
import { ModifierCommandUI } from 'Src/feature/modifier-command/ModifierCommandUI';

import styles from './ModifierButton.module.scss';

const sectionId = 'ModifierButton';

interface ModifierButtonProps {
  name: string;
  disabled: boolean;
  valid: boolean | undefined;
  required: boolean;
  selected: boolean;
  selections: { label: string; valid: boolean | undefined, depth: number; quantity?: number, command?: ModifierCommandUI }[];
  onClick: () => void;
}

const ModifierButton: FC<ModifierButtonProps> = ({
  name,
  disabled,
  selected,
  required,
  valid,
  selections,
  onClick,
  ...rest
}) => (
   
  <button
    {...rest}
    className={classNames(styles['root'], {
      [styles['required']]: required,
      [styles['valid']]: valid === true,
      [styles['invalid']]: valid === false,
      [styles['selected']]: selected,
    })}
    disabled={disabled}
    onClick={onClick}
  >
    <Copy className={styles.name}>{name}</Copy>
    <div className={styles.selections}>
      {
        selections.map((selection, i) => {
          let marginLeft = undefined as undefined | string;
          // margin should only be after 4th layer deep
          // - depth 0: root wrapper for tree
          // - depth 1: ItemCategory
          // - depth 2: MenuItem
          // - depth 3: first modifier group (Main Modifier Button)
          // - depth 4: second modifier group (shows up as first group under/inside Main Modifier Button)
          // - depth 5+: modifier group or modifier option (increment indentation)
          if (selection.depth > 4) {
            const increment = selection.depth - 4;
            marginLeft = `${increment * 0.75}rem`;
          }

          return (
            <Flex key={`${selection}-${i}`} horizontal gap="xs" alignItems="center" style={{ marginLeft }}>
              {selection.command && selection.command.intents.includes('badge') && selection.command?.model.type === 'prefix' && (
                <ModifierCommandPaletteChip label={selection.command.model.name} kind={selection.command.model.kind} />
              )}
              {/* only show quantity marker when quantity > 1 */}
              {(selection.quantity !== undefined && selection.quantity > 1) && <Copy type="xCount" value={selection.quantity} className={styles['selection_label']} />}
              <Copy className={styles['selection_label']}>{selection.label}</Copy>
              {selection.valid === false && <FontIcon name="warning" className={styles['selection-icon']} size="sm" color="error" /> }
              {selection.command && selection.command.intents.includes('badge') && selection.command?.model.type === 'suffix' && (
                <ModifierCommandPaletteChip label={selection.command.model.name} kind={selection.command.model.kind} />
              )}
            </Flex>
          );
        })
      }
    </div>
  </button>
);

export { ModifierButton, sectionId };
export type { ModifierButtonProps };
